/**
 * @generated SignedSource<<1af2a1ff63b996cda0a47e0ca86d4c89>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DatasetVersionTableRecordsFragment$data = {
  readonly id: string;
  readonly records: ReadonlyArray<any>;
  readonly " $fragmentType": "DatasetVersionTableRecordsFragment";
};
export type DatasetVersionTableRecordsFragment$key = {
  readonly " $data"?: DatasetVersionTableRecordsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DatasetVersionTableRecordsFragment">;
};

import DatasetVersionTableRecordsFragmentPaginationQuery_graphql from './DatasetVersionTableRecordsFragmentPaginationQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "limit"
    },
    {
      "defaultValue": 0,
      "kind": "LocalArgument",
      "name": "offset"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": DatasetVersionTableRecordsFragmentPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "DatasetVersionTableRecordsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "limit",
          "variableName": "limit"
        },
        {
          "kind": "Variable",
          "name": "offset",
          "variableName": "offset"
        }
      ],
      "kind": "ScalarField",
      "name": "records",
      "storageKey": null
    }
  ],
  "type": "DatasetVersion",
  "abstractKey": null
};

(node as any).hash = "d48a32a8e7c793fd2171b692a61f6607";

export default node;
